// TODO enable eslint
/* eslint-disable no-param-reassign */
import createSagaMiddleware from "redux-saga"
import EnhanceRedux from "../EnhanceRedux"

const sagaMiddleware = createSagaMiddleware()

export default EnhanceRedux(false, sagaMiddleware, false, store => {
  store.runReduxSaga = sagaMiddleware.run
  return store
})
